import { render } from "./DollCollection.vue?vue&type=template&id=349031fd&scoped=true"
import script from "./DollCollection.vue?vue&type=script&lang=js"
export * from "./DollCollection.vue?vue&type=script&lang=js"

import "./DollCollection.vue?vue&type=style&index=0&id=349031fd&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-349031fd"]])

export default __exports__